import { Formik, FormikProps } from 'formik'
import * as React from 'react'
import { History } from 'history'
import { Link, Redirect, RouteComponentProps } from 'react-router-dom'
import * as Yup from 'yup'
import { isTokenValid } from '../../utils/auth'
import Logo from '../icons/ui/Logo'
import NewPasswordForm from './NewPasswordForm'
import { IChangePasswordObj } from '../../types'
import { RecoveryTokenStatuses } from '../../constants/authentication'
import { withNotification } from '../ui/notification-provider'

interface INewPasswordFormikForm extends RouteComponentProps<{ token: string }> {
  isFetching: boolean
  isFetchSuccess: boolean
  recoverPasswordTokenStatus: string
  isLogged: boolean
  handleSubmit: (data: IChangePasswordObj) => void
  handleCheckToken: (token: string) => void
  error?: string
  history: History
  notification?: any
}

interface IValues {
  password: string
  passwordConfirmation: string
}

const NewPasswordFormWrap = (formikProps: FormikProps<any>) => <NewPasswordForm {...formikProps} />

const handleSubmit = (handleSubmit: (data: IChangePasswordObj) => void, token: string) => (
  values: IValues,
  { setFieldError }: { setFieldError: (field: string, message: string) => void }
) => {
  const { password, passwordConfirmation } = values
  if (password === passwordConfirmation) {
    handleSubmit({
      password,
      passwordConfirmation,
      passwordRecoveryToken: token
    })
  } else {
    setFieldError('password', 'New password and password confirmation must be equal')
  }
}

class NewPasswordFormikForm extends React.Component<INewPasswordFormikForm> {
  public componentDidMount() {
    if (
      !this.props.isFetching &&
      RecoveryTokenStatuses.IS_NOT_CHECKED === this.props.recoverPasswordTokenStatus &&
      this.props.isFetchSuccess !== true
    ) {
      this.props.handleCheckToken(this.props.match.params.token)
    }
  }
  public componentDidUpdate(prevProps: INewPasswordFormikForm) {
    if (this.props.isFetchSuccess && !prevProps.isFetchSuccess) {
      const { notification } = this.props
      notification.addNotification({
        title: 'Successfully reset password!',
        level: 'success'
      })
      this.props.history.push('/auth')
    }
  }
  public render() {
    if (this.props.isLogged || isTokenValid()) {
      return <Redirect to={`/trips`} />
    }

    if (this.props.isLogged === false && this.props.isFetchSuccess === true) {
      return <Redirect to={`/auth`} />
    }
    return (
      <div className='col-12 absolute top-0 bottom-0 left-0 right-0 flex flex-wrap direction-column justify-center items-center bg-green'>
        <div>
          <Logo className='margin-auto block icon--89x137' />
          {this.props.isFetching && <div className='h3 font-white bold center mt2'>Wait</div>}
          {/* remove later redirect to auth page when password is changed Date Written Feb. 2, 2022 */}
          {/* {this.props.isFetchSuccess && (
            <div className='w415 mt4'>
              <div className='fs-18 font-white bold center'>Password was changed!</div>
              <div className='fs-12 font-white mt1 center'>
                <Link className='fs-15 font-white mt1 center ml1 bb-white' to='/auth'>
                  Go back
                </Link>
              </div>
            </div>
          )} */}
          {this.props.recoverPasswordTokenStatus === RecoveryTokenStatuses.IS_NOT_VALID && (
            <div className='fs-18 font-white bold center mt2'>{this.props.error}</div>
          )}
          {this.props.recoverPasswordTokenStatus === RecoveryTokenStatuses.IS_VALID && (
            <Formik
              initialValues={{ password: '', passwordConfirmation: '' }}
              validationSchema={Yup.object().shape({
                password: Yup.string().required('New password'),
                passwordConfirmation: Yup.string().required('New password again')
              })}
              onSubmit={handleSubmit(this.props.handleSubmit, this.props.match.params.token)}
              render={NewPasswordFormWrap}
            />
          )}
        </div>
      </div>
    )
  }
}

export default withNotification(NewPasswordFormikForm)



// WEBPACK FOOTER //
// ./src/components/authentication/NewPasswordFormikForm.tsx